<script setup>
const props = defineProps({
    titulo: String,
    conteudo: String,
    detalhe: String,
    dica: String,
    tamanho_div: {
        type: String,
        default: 'col-12 md:col-4'
    }
})
</script>

<template>
    <div class="field mb-5 md:mb-4" :class="props.tamanho_div">
        <label for="nome" class="font-normal text-500 text-xs mb-1 block">
            {{ props.titulo }}
            <i v-if="props.dica" class="pi pi-info-circle text-500 ml-1" style="font-size: 0.7rem;"
                v-tooltip.top="{ value: props.dica }" />
        </label>
        <p class="text-900 text-sm font-semibold m-0" style="line-break: anywhere;">{{ props.conteudo }}</p>
        <p v-if="props.detalhe" class="text-500 font-medium text-xs mt-1 mb-0">{{ props.detalhe }}</p>
        <slot name="conteudo"></slot>
        <div class="text-500 font-normal text-xs flex flex-column" v-if="$slots.detalhe">
            <slot name="detalhe"></slot>
        </div>
    </div>
</template>